import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { listTimeZones } from 'timezone-support'
import { ModalContent, ModalActions } from '@the-platform-group/component-library/Modal'
import { Button } from '@the-platform-group/component-library/Button'
import { TextField, TypeaheadSingleSelect, Grid } from '@the-platform-group/component-library'

import { ROLES } from 'utils/auth'
const SharedFormFields = ({ user, onChange }) => {
  const { timeZone, role } = user
  return (
    <>
      <TypeaheadSingleSelect
        id="timeZone"
        name="timeZone"
        label="Time Zone"
        value={timeZone}
        onChange={(_e, newValue) => onChange({ target: { name: 'timeZone', value: newValue } })}
        variant="outlined"
        options={listTimeZones()}
      />
      <TypeaheadSingleSelect
        id="role"
        name="role"
        label="Role"
        value={role}
        onChange={(_e, newValue) => onChange({ target: { name: 'role', value: newValue } })}
        variant="outlined"
        options={ROLES}
      />
    </>
  )
}

const UserFormFields = ({ user, onChange }) => {
  const { firstName, lastName, email } = user
  return (
    <>
      <TextField
        label="First Name"
        name="firstName"
        value={firstName || ''}
        onChange={onChange}
        type="text"
        disabled
        sx={{ mt: 0.5, mb: 1 }}
        fullWidth
      />
      <TextField
        label="Last Name"
        name="lastName"
        value={lastName || ''}
        onChange={onChange}
        type="text"
        disabled
        sx={{ mt: 0.5, mb: 1 }}
        fullWidth
      />
      <TextField
        label="Email"
        name="email"
        value={email || ''}
        onChange={onChange}
        type="email"
        disabled
        sx={{ mt: 0.5, mb: 1 }}
        fullWidth
      />
    </>
  )
}

const UserForm = ({ onClose, onChange, onSave, onInvite, user, isLoading, isFormEdited }) => {
  return (
    <Fragment>
      <ModalContent>
        <form>
          <UserFormFields user={user} onChange={onChange} />
          <SharedFormFields user={user} onChange={onChange} />
        </form>
      </ModalContent>
      <ModalActions>
        <Grid container direction="row">
          <Grid item xs={6} justifyContent="flex-start">
            <Button onClick={onInvite} disabled={isFormEdited}>
              Send Invitation
            </Button>
          </Grid>
          <Grid item container xs={6} justifyContent="flex-end" spacing={1}>
            <Grid item>
              <Button onClick={onClose}>Cancel</Button>
            </Grid>
            <Grid item>
              <Button onClick={() => onSave(onClose)} disabled={isLoading}>
                Submit
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </ModalActions>
    </Fragment>
  )
}

UserForm.propTypes = {
  user: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onInvite: PropTypes.func.isRequired,
}

export default UserForm
